import * as myActions from '~/actions/me';

const defaultState = {
  me: undefined,
  isLoggedIn: false,
};

const myState = (state = defaultState, action) => {
  switch (action.type) {
    case myActions.UPDATE_ME:
      return Object.assign({}, state, {
        me: action.me,
        isLoggedIn: !!action.isLoggedIn,
      });
    default:
      return state;
  }
};

export default myState;

export const getCurrentUser = state => state;

export const isSiteAdmin = state => {
  const { me } = state;
  return !!me && !!me.roles && me.roles.indexOf('ADMIN') > -1;
};
